/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserSaveInput = {
    name: string;
    surname: string;
    contactNumber: string;
    profileImage?: unknown | null;
};
export type ProfileEditDetailsMutationVariables = {
    input: UserSaveInput;
};
export type ProfileEditDetailsMutationResponse = {
    readonly userSave: {
        readonly user: {
            readonly profile: {
                readonly name: string;
                readonly surname: string;
                readonly contactNumber: string;
                readonly profileImageURL: string;
            } | null;
        };
    };
};
export type ProfileEditDetailsMutation = {
    readonly response: ProfileEditDetailsMutationResponse;
    readonly variables: ProfileEditDetailsMutationVariables;
};



/*
mutation ProfileEditDetailsMutation(
  $input: UserSaveInput!
) {
  userSave(input: $input) {
    user {
      profile {
        name
        surname
        contactNumber
        profileImageURL
        id
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surname",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactNumber",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileImageURL",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileEditDetailsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSavePayload",
        "kind": "LinkedField",
        "name": "userSave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileEditDetailsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSavePayload",
        "kind": "LinkedField",
        "name": "userSave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9860910d99bae9972b2ee0e8e78dcd08",
    "id": null,
    "metadata": {},
    "name": "ProfileEditDetailsMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileEditDetailsMutation(\n  $input: UserSaveInput!\n) {\n  userSave(input: $input) {\n    user {\n      profile {\n        name\n        surname\n        contactNumber\n        profileImageURL\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ad2552c8f1bc38fbdff1edabbc880364';
export default node;
